<div class="card file-viewer">
  <div class="card-header">
    <span class="card-title">{{ data.fileName }}</span>
    <button mat-mini-fab class="closex" color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="card-body file-viewer-body">
    <ng-container *ngIf="!loading && !error && safeUrl">
      <img
        *ngIf="kind == 'image'"
        class="file-viewer-image"
        [src]="safeUrl"
        alt="{{ data.fileName }}"
      />
      <iframe
        *ngIf="kind == 'frame'"
        class="file-viewer-frame"
        [src]="safeUrl"
        title="{{ data.fileName }}"
      ></iframe>
      <video
        *ngIf="kind == 'video'"
        class="file-viewer-image"
        [src]="safeUrl"
        controls
      ></video>
    </ng-container>

    <div class="file-viewer-empty" *ngIf="!loading && (kind == 'none' || error)">
      <img class="icon" alt="file" src="{{ data.fileIcon }}" />
      <span *ngIf="!error">Preview is not available for this file type.</span>
      <span *ngIf="error">The file could not be loaded.</span>
    </div>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="loading"
        (click)="openInNewTab()"
      >
        <mat-icon>open_in_new</mat-icon> Open in New Tab
      </button>
      <button class="ml-2" mat-flat-button color="primary" (click)="download()">
        <mat-icon>download</mat-icon> Download
      </button>
    </div>
  </div>
</div>
